export enum ObjetoEnum {
  TelaAnimal = "Tela Animais",
  TelaVeiculo = "Tela Veículos",
  TelaCenario = "Tela Cenários",
  TelaCena = "Tela Cenas",
  TelaCenasBotaoInclusaoPersonagem = "Tela Cenas - Botão Inclusão de Personagem",
  TelaCenasBotaoInclusaoFiguracao = "Tela Cenas - Botão Inclusão de Figuração",
  TelaCenasBotaoInclusaoVeiculos = "Tela Cenas - Botão Inclusão de Veículos",
  TelaCenasBotaoInclusaoMaterial = "Tela Cenas - Botão Inclusão de Material",
  TelaCenasBotaoInclusaoAnimais = "Tela Cenas - Botão Inclusão de Animais",
  TelaEquipe = "Tela Equipe",
  TelaEstudio = "Tela Estúdio",
  TelaFigurante = "Tela Figurações",
  TelaFita = "Tela Fita",
  TelaLocacao = "Tela Locações",
  TelaMaterial = "Tela Materiais",
  TelaPersonagem = "Tela Personagem",
  TelaAgenda = "Tela Agenda",
  TelaRoupa = "Tela Roupas",
  TelaRoupasCampoObservacaoFigurino = "Tela Roupas - Campo Observação Figurino",
  TelaRoteiro = "Tela Roteiro",
  TelaRoteiroBotaoHorario = "Tela Roteiro - Botão Horário",
  TelaRoteiroBotaoEspelhoGravacao = "Tela Roteiro - Botão Espelho de Gravação",
  TelaCapitulo = "Tela Capítulo",
  TelaCenasBotaoContinuidade = "Tela Cenas - Botão Continuidade",
  TelaFiguracaoBotaoFichaRoupa = "Tela Figuração - Botão Ficha de Roupa",
  TelaCenasBotaoInclusaoFigurino = "Tela Cenas - Botão Inclusão de Figurino",
  TelaRelatorioGravacao = "Tela Relatório de Gravação",
  TelaRelatorioGravacaoBotaoExibir = "Tela Relatório de Gravação - Botão Exibir",
  TelaRelatorioEstatisticaGravacaoBotaoExibir = "Tela Relatório Estatística de Gravação - Botão Exibir",
  TelaRelatorioOcorrenciaBotaoExibir = "Tela Relatório de Ocorrência - Botão Exibir",
  TelaRoteiroBotaoDecupagemArtistica = "Tela Roteiro - Botão Decupagem Artística",
  TelaRelatorioCapituloContinuidadeBotaoExibir = "Tela Relatório de Capítulo/Continuidade - Botão Exibir",
  TelaGravacao = "Tela Gravação",
  TelaDashboard = "Tela Dashboard",
  TelaAcessoEmail = "Tela Acesso por E-mail",
  TelaPerfil = "Tela Perfil",
  TelaPermissoesPorPerfil = "Tela Permissões por perfil",
  TelaProduto = "Tela Produto",
  TelaUsuario = "Tela Usuário",
  TelaAmbiente = "Tela Ambiente",
  TelaCargo = "Tela Cargo",
  TelaRelatorioBingo = "Tela Relatório Bingo",
  TelaRelatorioFiguranteRoupa = "Tela Relatório Figurante Roupa",
  TelaRelatorioRoteiro = "Tela Relatório Roteiro",
  TelaRelatorioRoteiroContinuidade = "Tela Relatório Roteiro Continuidade",
  TelaRelatorioPersonagemRoupa = "Tela Relatório Personagem Roupa",
  TelaRelatorioPedidoRoupa = "Tela Relatório Pedido de Roupa",
  TelaRelatorioCapitulosFinalizados = "Tela Relatório Capítulos Finalizados",
  TelaRelatorioEstatisticaGravacao = "Tela Relatório Estatística de Gravação",
  TelaRelatorioOcorrencias = "Tela Relatório Ocorrências",
  TelaOcorrencia = "Tela Ocorrências",
  TelaRelatorioCapituloContinuidade = "Tela Relatório Capítulo Continuidade",
  TelaRelatorioRoteiroDecupagem = "Tela Relatório Roteiro Decupagem",
  TelaRelatorioCapitulo = "Tela Relatório Capítulo",
}

export enum PermissaoEnum {
  Acessar = "Acessar",
  Salvar = "Salvar",
  Visualizar = "Visualizar",
  Editar = "Editar",
  Excluir = "Excluir",
  Teste = 'Teste'
}
